import React, { ReactElement } from 'react';
import { DatePicker, FormGroup, Label } from 'idsk-react-components';
import { LdapSearchItem } from 'pripomienky-web-ts-axios';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import AddSubjektBezPripomienokFormButtons from './AddSubjektBezPripomienokFormButtons';
import { SearchPouzivatelskaSkupina } from '../../SearchLdapData';
import './addSubjektBezPripomienokForm.scss';

interface Props {
  onSubmit: () => void;
  loading?: boolean;
  date: Date;
  setDate: (date: Date) => void;
  skupina: LdapSearchItem;
  setSkupina: (skupina: LdapSearchItem) => void;
}

const AddSubjektBezPripomienokForm = ({
  onSubmit,
  date,
  setDate,
  skupina,
  setSkupina,
  loading,
}: Props): ReactElement => {
  const { getFieldErrorMessage } = useFieldErrorMessages();
  const minDate = new Date();
  minDate.setFullYear(minDate.getFullYear() - 10);

  return (
    <form className="add-subjekt-bez-pripomienok-admin-form">
      <SearchPouzivatelskaSkupina
        skupina={skupina}
        setSkupina={setSkupina}
        label="Subjekt bez pripomienok"
      />
      <FormGroup
        error={!!getFieldErrorMessage('datumOdoslania')}
        className="border-divider"
      >
        <Label htmlFor="datumOdoslania"> Dátum odoslania bez pripomienok</Label>
        <DatePicker
          id="datumOdoslania"
          error={getFieldErrorMessage('datumOdoslania')}
          width="one-third"
          value={date}
          onChange={(data) => setDate(data == null ? new Date() : data)}
          minDate={minDate}
          maxDate={new Date()}
        />
      </FormGroup>
      <AddSubjektBezPripomienokFormButtons
        loading={loading}
        onSubmit={onSubmit}
      />
    </form>
  );
};

export default AddSubjektBezPripomienokForm;
